import styled from 'styled-components'

// SearchWrapper removed (using Tonality.TextField directly)

export const Container = styled.div`
  width: 100%;
`

export const IpadLayout = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 32px 16px 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const DesktopLayout = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 32px 64px 0 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`

export const MobileLayout = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 16px; /* 16 side margins per spec */
  display: flex;
  flex-direction: column;
  gap: 16px; /* vertical spacing between rows */
`

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const LeftGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`

export const SearchButton = styled.button`
  outline: none;
  border: none;
  background: transparent;
  width: 40px; /* w-10 */
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const BackButton = styled.button`
  outline: none;
  border: none;
  background: transparent;
  width: 32px;
  height: 32px;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

// SearchBarShell/SearchInput/ClearButton removed (TextField handles UI)

export const GlobalActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  flex-shrink: 0;
`

// CloseSearchLink removed (no close button in new input)
